import { render, staticRenderFns } from "./ProductionStatus.vue?vue&type=template&id=635fedec&scoped=true"
import script from "./ProductionStatus.vue?vue&type=script&lang=js"
export * from "./ProductionStatus.vue?vue&type=script&lang=js"
import style0 from "./ProductionStatus.vue?vue&type=style&index=0&id=635fedec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635fedec",
  null
  
)

export default component.exports